import LoadingPage from '@/component/loading';
import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';
import useAccess from '@/TRC/hooks/useAccess';
import TRCRequestPage from '@/TRC/pages/Access/Request';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TRCResubmit = () => {
	const { hasAccess, needsAccess, loading, initialLoad } = useAccess();
	const navigate = useNavigate();
	useEffect(() => {
		if (hasAccess) {
			navigate(TRC_ROUTES.TRC_HOME);
		} else if (needsAccess) {
			navigate(TRC_ROUTES.ACCESS);
		}
	}, [hasAccess]);

	if (loading || initialLoad) return <LoadingPage />;
	return (
		<div
			className="w-100 d-flex justify-content-center align-items-center pt-5 pt-md-0"
			style={{ backgroundColor: '#171718', minHeight: '100svh' }}
		>
			<div className="container-md w-100 d-flex flex-column justify-content-center align-items-center">
				<TRCRequestPage />
			</div>
		</div>
	);
};

export default TRCResubmit;
